import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import Text from '../Text';

export const AutoSave = ({ autoSaved }) => {
  const { t } = useTranslation('tileForm');

  return (
    <Wrapper>
      {autoSaved.status === 'saving' && (
        <AutoSaveText>
          <i className="fa-regular fa-arrows-rotate" />
          {t('autosave.saving')}
        </AutoSaveText>
      )}
      {autoSaved.status === 'saved' && (
        <AutoSaveText
          data-tip={t('autosave.tooltip', { time: autoSaved.time })}
        >
          <i className="fa-regular fa-check" />
          {t('autosave.saved')}
        </AutoSaveText>
      )}
      {autoSaved.status === 'error' && (
        <AutoSaveErrorText data-tip={t('autosave.errorTooltip')}>
          <i className="fa-regular fa-triangle-exclamation" />
          {t('autosave.error')}
        </AutoSaveErrorText>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  justify-self: start;
  grid-area: auto-save;
  margin-left: 12px;
`;

const AutoSaveText = styled(Text).attrs({ variant: 'small2' })`
  display: flex;
  gap: 6px;
  align-items: center;
`;

const AutoSaveErrorText = styled(AutoSaveText)`
  color: ${({ theme }) => theme.colors.error.default};
`;
